module.exports = __webpack_public_path__ + "static/img/enter-now.7476bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/BoxingCamp/img/button-area/enter-now.png
// module id = 480
// module chunks = 0